module.exports = __webpack_public_path__ + "img/RORBPJS40075.42c3b16b.png";